import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';

const routes: Routes = [{
  path: '',
  component: AppComponent,
  children: [
    {
      path: '',
      loadChildren: () => import('./client-auth/client-auth.module').then(m => m.ClientAuthModule)
    }
  ]
}
  // { path: 'home', component: HomeComponent},
  // { path: 'pickup', component: PickUpComponent},
  // { path: 'delivery', component: DeliveryComponent},
  // { path: 'track', component: TrackComponent},

  // {path: 'register',component: RegisterComponent},
  // {path: 'login',component: LoginComponent},
  // {path: 'reset',component: ResetPasswordComponent},
  // {path: 'forgot', component:ForgotPasswordComponent}
  // { path: '', redirectTo: 'login',pathMatch: 'full',},
];

export const AppRoutingModule = RouterModule.forRoot(routes);
